export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-15.jpg'),
        title: 'GLOBALIZATION & LOCALIZATION',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'GLOBALIZATION & LOCALIZATION',
      description: `<p style="font-size:1.5rem">Maesinfo. is an innovative service company specializing in providing intelligent IT solutions for world-renowned enterprises and large organizations, headquartered in Chengdu, a famous Chinese software city. Main business includes software (application software, mobile phone software, embedded software, etc.), development services, IT solutions, QA/QC services, system integration, software maintenance and IT infrastructure maintenance services, while providing customers with a full range of business process outsourcing solutions including data entry, data processing, data cleaning, call services, personnel training and so on. MaesInfo has maintained a relatively rapid growth rate in recent years with the help of the national reform and opening-up policy and the concern, support and assistance of Party committees, governments and all sectors of society at all levels.
Branches have been established in Shenzhen, Changzhou and Xi'an.
</p>`
    },
    {
      title: 'GLOBALIZATION:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-15.jpg')+`)"></span>
      <span>MaesInfo has market and project management centers in Mountain View and Pittsburgh. In terms of talent reserve, MaesInfo recruits talented people in various technical and professional fields globally. At present, its employees come from many countries and regions around the world (such as China, India, the United States, Canada, Philippines, Hong Kong, etc.)</span>`
    }
  ]
}
